<template>
  <el-dialog
    title="Iktatás megtekintése"
    :visible="true"
    width="700px"
    :close-on-click-modal="false"
    @close="$router.replace('/docket/dockets')"
  >
    <el-tabs
      v-model="activeName"
      v-loading="loading"
    >
      <el-tab-pane
        label="Alapadatok"
        name="1">
        <el-table
          :data="docketData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.tag"
                :type="scope.row.tagType || 'danger'"
                size="small"
              >
                {{ scope.row.value }}
              </el-tag>
              <span
                v-if="!scope.row.tag"
                style="word-break: normal;"
              >
                {{ scope.row.value }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        v-if="docket && docket.document_type && docket.document_type.extra_fields"
        label="Extra mezők"
        name="2"
      >
        <el-table
          :data="docket.document_type.extra_fields"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.name }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <span
                style="word-break: normal;"
              >
                <span v-if="scope.row.type === 'date'">{{ docket.extra_fields[scope.row.name] | date }}</span>
                <span v-if="scope.row.type === 'currency'">{{ docket.extra_fields[scope.row.name] }} {{ cc && docket.extra_fields[scope.row.name] && cc.code(docket.extra_fields[scope.row.name]) && cc.code(docket.extra_fields[scope.row.name]).currency }}</span>
                <span v-if="scope.row.type !== 'date' && scope.row.type !== 'currency'">{{ docket.extra_fields[scope.row.name] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Fájlok"
        name="3"
      >
        <files
          :files="docket.files"
          :dialog-type="'view'"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
      v-can="['docket.delete', 'docket.update']"
    >
      <el-button
        @click="$router.replace('/docket/dockets/update/' + docket.id)"
        type="primary"
        icon="el-icon-edit"
        v-can="'docket.update'"
      >
        Módosítás
      </el-button>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
        v-can="'docket.delete'"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteProduct()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
const cc = require('currency-codes');
import Files from './Files';

export default {
  components: { Files },
  props: ['docketId'],
  data() {
    return {
      activeName: '1',
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
      loading: false,
      buttonLoading: false,
      filterInput: '',
      docket: {},
      docketData: [],
      cc,
    };
  },

  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.docket = await this.$store.dispatch('docket/fetch', this.docketId);
      this.docketData = [
        {
          label: 'Azonosító',
          value: this.docket.id
        },
        {
          label: 'Irány',
          value: this.docket && this.docket.type === 'in' && 'Bejövő' || this.docket && this.docket.type === 'out' && 'Kimenő' || this.docket && this.docket.type === 'internal' && 'Belső'
        },
        {
          label: 'Irattipus',
          value: this.docket && this.docket.document_type && this.docket.document_type.name,
        },
        {
          label: 'Honnan',
          value: this.docket && this.docket.from_name,
        },
        {
          label: 'Hova',
          value: this.docket && this.docket.to_name,
        },
        {
          label: 'Hivatkozási szám',
          value: this.docket && this.docket.reference_number
        },
        {
          label: 'Határidő',
          value: this.docket && this.$options.filters.dateTime(this.docket.deadline)
        },
        {
          label: 'Iktatókönyv',
          value: this.docket && this.docket.docket_book && this.docket.docket_book.name
        },
        {
          label: 'Előzmény',
          value: this.docket && this.docket.related_docket && this.docket.related_docket.document_type && `POP - ${this.docket.related_docket.id} (${this.docket.related_docket.document_type.name})`
        },
        {
          label: 'Felelős',
          value: this.docket && this.docket.responsible_user && this.docket.responsible_user.full_name
        },
        {
          label: 'Felelős határideje',
          value: this.docket && this.$options.filters.dateTime(this.docket.responsible_user_deadline)
        },
        {
          label: 'Módosítva',
          value: this.docket && this.$options.filters.dateTime(this.docket.updated_at)
        },
        {
          label: 'Létrehozva',
          value: this.docket && this.$options.filters.dateTime(this.docket.created_at)
        },
      ];
      this.loading = false;
    },
    async deleteProduct() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('docket/delete', this.productId);
        this.$store.dispatch('docket/fetchAll');
        this.$router.replace('/docket/dockets');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },

    getStatusName(status) {
      switch (status) {
        case 'inactive':
          return {
            label: 'Inaktív',
            tag: 'danger',
          };
        case 'active':
          return {
            label: 'Aktív',
            tag: 'success',
          };
        case 'run-out':
          return {
            label: 'Kifutó',
            tag: 'primary',
          };
        case 'run-out-inactive':
          return {
            label: 'Kifutó és inaktív',
            tag: 'warning',
          };
        case 'hidden':
          return {
            label: 'Láthatatlan',
            tag: 'info',
          };
        default:
          return {
            label: '',
            tag: 'info',
          };
      }
    },

    getDirectionValue() {
      const direction = {
        from: '',
        to: ''
      };
      if (this.docket && this.docket.type === 'in') {
        direction.from = this.docket && this.docket.from && this.docket.from.company && this.docket.from.company.name;
        direction.to = this.docket && this.docket.to && this.docket.to.name;
      }
      if (this.docket && this.docket.type === 'out') {
        direction.from = this.docket && this.docket.to && this.docket.to.name;
        direction.to = this.docket && this.docket.from && this.docket.from.company && this.docket.from.company.name;
      }
      if (this.docket && this.docket.type === 'internal') {
        direction.from = this.docket && this.docket.to && this.docket.to.name;
        direction.to = this.docket && this.docket.to && this.docket.to.name;
      }
      return direction;
    }
  },
};
</script>
<style lang="scss">
  .stock-table {
    .product-column {
      .cell {
        word-break: break-word;
      }
    }
  }

</style>

